import { createStyles } from '@mantine/styles';


export default createStyles((theme: {
    colors: { [x: string]: any[] };
    white: string;
    fontSizes: any;
    spacing: any;
    radius: any;
    fn: any;
    colorScheme: any;
    other: any;
}) => ({

    galleryContainer: {
        maxWidth: theme.other.maxWidth,

        'span': {
            height: '100% !important',
            width: '100% !important',
        },
    },

    imageStyles: {
        borderRadius: theme.radius.xs,
        cursor: 'pointer',
    }

}));
